import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-release-manager',
  templateUrl: './release-manager.component.html',
  styleUrls: ['./release-manager.component.scss']
})
export class ReleaseManagerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
